import { useEffect, useReducer } from "react";
import { computeDropdownSelectedIndex } from "../../utils/computeDropdownSelectedIndex.js";
import { formatValue } from "../../utils/formatValue.js";
import { parseDuration } from "../../utils/parseDuration/parseDuration.js";
import { durationInputStateReducer } from "./durationInputStateReducer.js";
import { computeDropdownOptions } from "./useDropdownOptions.js";
function useDurationInputState(props) {
  const { value, format, onChange, optionValues } = props;
  const [state, dispatch] = useReducer(durationInputStateReducer, { value, format, optionValues }, computeInitialState);
  const { fieldValue, dirty, initialValue } = state;
  useEffect(() => {
    if (!dirty && fieldValue === initialValue) return;
    onChange(fieldValue);
  }, [fieldValue, onChange, dirty, initialValue]);
  useEffect(() => {
    dispatch({ type: "reaction/change:value", value });
  }, [value]);
  useEffect(() => {
    dispatch({ type: "reaction/change:format", format });
  }, [format]);
  useEffect(() => {
    dispatch({ type: "reaction/change:dropdownOptions", format, optionValues });
  }, [format, optionValues]);
  return { state, dispatch };
}
function computeInitialState(props) {
  const { value, format, optionValues } = props;
  const displayValue = formatValue(value, format);
  const parsedValue = parseDuration(displayValue, format);
  const error = parsedValue === "invalidFormat" ? "invalidFormat" : null;
  const dropdownOptions = computeDropdownOptions(format, optionValues);
  return {
    error,
    open: false,
    dirty: false,
    format,
    fieldValue: value,
    initialValue: value,
    displayValue: formatValue(value, format),
    dropdownOptions,
    dropdownSelectedIndex: computeDropdownSelectedIndex(value, dropdownOptions)
  };
}
export {
  useDurationInputState
};
//# sourceMappingURL=useDurationInputState.js.map
